import request from "@/utils/request";

// 列表(主数据列表)
export function loadMaterialsSchemeTraceSendDaySettingListDataApi(data) {
    return request({
      url: "web/materialsSchemeTraceSendDaySetting/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadMaterialsSchemeTraceSendDaySettingExportDataApi(data) {
    return request({
      url: "web/materialsSchemeTraceSendDaySetting/exportData",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateMaterialsSchemeTraceSendDaySettingApi(data) {
    return request({
      url: "web/materialsSchemeTraceSendDaySetting/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initMaterialsSchemeTraceSendDaySettingApi(data) {
    return request({
      url: "web/materialsSchemeTraceSendDaySetting/init",
      method: "post",
      data
    });
  }